module.exports = __webpack_public_path__ + "static/faviconUT-be6029e02bb2d6e0415a561c42641a2f.ico";